<template>
    <div class="QueryWidget">
        <template v-if="q.structuredQuery">
            <span v-for="(sq, sKey) in q.structuredQuery.rows" :key="sKey">
                <span v-if="sq.operator">{{sq.operator}}</span>
                <span>{{sq.query}}</span>
            </span>
        </template>
        <template v-else>
            <span v-html="formatQueryNotions(q.query)"> </span>
        </template>
    </div>
</template>

<script>
    import mixins from "../common/mixin";

    export default {
        name: "QueryWidget",
        mixins: [mixins],
        props: {
            q: {
                type: Object,
                default: () => ({})
            }
        }
    }
</script>

<style scoped lang="scss">
    .QueryWidget {
        max-width: 35vw;
        padding: 3px 6px;
        border-radius: 4px;
        background: #fff;
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 13px;

        > span {
            display: inline-flex;
            gap: 5px;
            align-items: center;
        }

    }
</style>